<template>
<div id="account-deletion-modal" class="modal modal-right fade" data-backdrop="static" role="dialog">

    <div class="modal-dialog modal-xl" role="document">
        <div ref="section" class="modal-content">
            <div class="modal-header bg-dark">
                <h6 class="modal-title">{{ $t('Account Deletion') }}</h6>
                <button type="button" class="close" @click="closeModal()" ref="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body pt-0 pb-5">
                <AccountDeletionInfo v-if="isTermsAndConditions"></AccountDeletionInfo>
                <Verification v-if="isVerification" />
                <VerificationCode v-if="isVerificationCode" ref="code"/>

            </div>
                
            <div class="modal-footer modal-footer-fixed bg-light py-2 border-bottom justify-content-center">
                <template v-if="isTermsAndConditions">
                    <button @click="showVerificationOption()" :disabled="!isAgree" type="button" class="btn btn-primary mr-2">
                        <i class="fa-solid fa-circle-arrow-right mr-1"></i>{{ $t("Next") }}
                    </button>
                    <button @click="closeModal()" type="button" class="btn btn-light">
                        {{ $t("Cancel") }}
                    </button>
                </template>
                <template v-if="isVerification">
                    <button @click="showVerificationCodeForm()" :disabled="!verifyMethodId" type="button" class="btn btn-primary mr-2" :class="[loading ? 'disabled' : '']">
                        <i :class="[loading ? 'icon-spinner2 spinner' : 'fa-solid fa-paper-plane','mr-1',]"></i>{{ $t("Send code") }}
                    </button>
                    <button @click="showSummaryLists()" type="button" class="btn btn-light">
                        {{ $t("Back") }}
                    </button>
                </template>
                <template v-if="isVerificationCode">
                    <button @click="confirmCode()" type="button" class="btn btn-primary mr-2" :class="[loading ? 'disabled' : '']">
                        <i :class="[loading ? 'icon-spinner2 spinner' : 'fa-regular fa-circle-check','mr-1',]"></i>{{ $t("Confirm") }}
                    </button>
                    <button @click="showVerificationOption()" type="button" class="btn btn-light">
                        {{ $t("Back") }}
                    </button>
                </template>

            </div>
           
        </div>
    </div>
</div>
</template>

<script>
import AccountDeletionInfo from "./AccountDeletionInfo.vue";
import Verification from "./Verification";
import VerificationCode from "./VerificationCode";
import CentralApi from '@/services/endpoint/central.service'
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'

export default {
    name: "ModalDeleteStore",
    components: {
        AccountDeletionInfo,
        Verification,
        VerificationCode,
        PlaceholderContent,
    },
    data() {
        let vm = this;
        return {
            isTermsAndConditions: true,
            isVerification: false,
            isVerificationCode: false,
            isAgree: false,
            storeData: {
                storeName: 'Patrick My Shop',
                email: 'Patrickmyshop@gmail.com',
                phone: '0989999999'
            },
            verificationCode: '',
            refCodeId: '',
            verifyMethodId: null,
            loading: false
        };

    },
    props: {
      userData: {
          type: Object,
          default() {
              return {
                id: '',
                firstName: '',
                email: '',
                mobile: '',
              }
          }
      },
    },
    methods: {
        closeModal() {
            this.isAgree = false;
            this.addLoading(false);
            this.$refs.close.click();
        },
        showSummaryLists() {
            this.isTermsAndConditions = true;
            this.isVerification = false;
            this.isVerificationCode = false;
            this.addLoading(false);
        },
        showVerificationOption() {
            this.isTermsAndConditions = false;
            this.isVerification = true;
            this.isVerificationCode = false;
            this.addLoading(false);
        },
        async showVerificationCodeForm() {
            this.addLoading(true);
            if (this.verifyMethodId == 1) {
                let allow = await CentralApi.Auth.iswhitelistEmail(this.userData.email);
                if(!allow.data.whitelist){
                    let notAllowed = await CentralApi.Auth.isblacklistEmail(this.userData.email);
                    if(notAllowed.data.blacklist){
                        this.addLoading(false);
                        this.$toastr.Add({
                            type: "warning",
                            title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                            msg: this.$t("Email cannot be sent to")+" "+
                                this.userData.email+" "+
                                this.$t("because this recipient is in blacklist.")+" "+
                                this.$t("If you feel this is a mistake, contact your admin."),
                            clickClose: true,
                            timeout: 5000,
                            position: "toast-top-right"
                        });
                        return false;
                    }
                }
                let data = {
                    'firstName' : this.userData.name,
                    'email' : this.userData.email
                };
                try {
                    let sendVerify = await CentralApi.User.sendVerifyMailDeleteAccount(data);
                    this.verificationCode = sendVerify.data.randomNumber;
                    this.refCodeId = sendVerify.data.refcode;
                    this.isTermsAndConditions = false;
                    this.isVerification = false;
                    this.isVerificationCode = true;
                    this.addLoading(false);
                    return true;
                } catch (error) {
                    this.addLoading(false);
                    let message = error.response.data.message;
                    if(message == "This email is blacklisted.") {
                        message = this.$t("Email cannot be sent to")+" "+
                                this.userData.email+" "+
                                this.$t("because this recipient is in blacklist.")+" "+
                                this.$t("If you feel this is a mistake, contact your admin.");
                    }
                    this.$toastr.Add({
                        type: "warning",
                        title: "<span class='icon-warning22 mr-2'></span>"+this.$t('Something went wrong.'),
                        msg: message,
                        clickClose: true,
                        timeout: 5000,
                        position: "toast-top-right"
                    });
                    return false;
                }
            } else if (this.verifyMethodId == 2) {
                let data = {
                    'telephone' : this.userData.mobile,
                    'message' : 'กรุณากรอกรหัส {OTP} เพื่อยืนยันการลบบัญชี รหัสนี้จะหมดอายุภายใน 60 วินาที',
                };
                let sendVerify = await CentralApi.User.sendVerifySmsDeleteAccount(data);
                this.verificationCode = sendVerify.data.randomNumber;
                this.refCodeId = sendVerify.data.refcode;
                this.isTermsAndConditions = false;
                this.isVerification = false;
                this.isVerificationCode = true;
                this.addLoading(false);
            }
        },
        confirmCode() {
            this.$refs.code.handleVerficationCode();
        },
        addLoading(status) {
            this.loading = status;
        },
    },

};
</script>



// WEBPACK FOOTER //
// src/components/central/account/security/ModalDeleteAccount.vue